module.exports = __webpack_public_path__ + "img/Umb41_uv_logotie_5583.664e12ad.svg";